<script>
	import AccountHeader from '../../components/account/AccountHeader.svelte';
	import AccountNav from '../../components/account/AccountNav.svelte';
	import { userData } from '../../js/stores';
	import { push, replace } from 'svelte-spa-router';
	import { API_URL } from '../../../env';
	import updateUserData from '../../js/updateUserData';
	import checkLoginValidity from '../../lib/checkLoginValidity';

	window.scrollTo(0, 0);
	if ($userData === null) replace('/?m=prihlasit-sa');

	const body = {
		name: $userData?.name || '',
		surname: $userData?.surname || ''
	};
	let isSaving = false;

	async function changePersonalData() {
		if (isSaving) return;
		isSaving = true;

		let fetchBody = {
			...body
		};
		if (fetchBody.name.length === 0) fetchBody.name = null;
		if (fetchBody.surname.length === 0) fetchBody.surname = null;

		const res = await fetch(API_URL + '/users/name', {
			method: 'PUT',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(fetchBody)
		});

		isSaving = false;
		if (!res.ok) {
			if (checkLoginValidity(res.status)) return await push('/?m=prihlasit-sa');
			alert('Údaje sa nepodarilo uložiť. Skúste to prosím znova.');
		} else {
			await updateUserData();
		}
	}
</script>

<section class="container" id="account">

	<AccountHeader />

	<div class="account">

		<AccountNav />

		<div class="account-content">
			<h2>Osobné údaje</h2>
			<p>Tu si môžete upraviť svoje osobné údaje.</p>
			<div class="row">
				<div class="col-sm-6 col-lg-4 mb-4">
					<div class="input-group">
						<label for="firstname">Meno</label>
						<input id="firstname" type="text" placeholder="{$userData?.name || ''}" bind:value={body.name}>
					</div>
				</div>
				<div class="col-sm-6 col-lg-4 mb-4">
					<div class="input-group">
						<label for="surname">Priezvisko</label>
						<input id="surname" type="text" placeholder="{$userData?.surname || ''}" bind:value={body.surname}>
					</div>
				</div>
				<div class="col-sm-6 col-lg-4 mb-4">
					<div class="input-group">
						<label for="email">E-mail</label>
						<input id="email" type="email" placeholder="{$userData?.email || ''}" disabled>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-lg-12 d-flex align-items-center justify-content-end">
					<button type="button" class="btn btn-primary btn-responsive" on:click={changePersonalData}>
						{#if isSaving}
							<i class="fas fa-fw fa-spinner-third fa-spin mr-2"></i>Ukladanie...
						{:else}
							<i class="fas fa-fw fa-save mr-2"></i>Uložiť
						{/if}
					</button>
				</div>
			</div>
		</div>
	</div>
</section>